import InstitutionConstraintsCard from './InstitutionConstraintsCard'

import './assets/constraints.scss'

const Constraints = () => {
  return (
    <div className='constraints'>
      <InstitutionConstraintsCard />
    </div>
  )
}

export default Constraints
